<template>
  <bita-modal
    id="measure-form"
    :title="title"
    :is-loading="isLoading"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="title"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.title"
            />
            <bita-select
              type="text"
              name="send_email"
              label="ارسال ایمیل"
              ref="emailSelect"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="dataSource"
              data-text-field="name"
              data-value-field="value"
              v-model="formData.send_email"
            />
            <bita-select
              type="text"
              name="send_sms"
              label="ارسال پیامک"
              ref="smsSelect"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="dataSource"
              data-text-field="name"
              data-value-field="value"
              v-model="formData.send_sms"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!formData.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="save"
      />
      <bita-bootbutton
        v-else
        title="بروزرسانی"
        type="primary"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    title: String,
    isLoading: Boolean,
    measure: Object,
  },
  data() {
    return {
      colWidth: "col-lg-4",
      formData: {},
      dataSource: [
        {value: 0, name: 'خیر'},
        {value: 1, name: 'بله'}
      ]
    };
  },
  computed: {

  },
  methods: {
    setForm(data) {
      this.formData = data;
    },
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-create", this.formData);
        }
      });
    },
    update() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-update", this.formData);
        }
      });
    },
    reset() {
      this.formData = {};
      this.$refs.form.reset();
      this.$refs.smsSelect.emptyKendo();
      this.$refs.emailSelect.emptyKendo();
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>
